// filters
export const vacanciesFilterKeys = {
  groupId: 'groupId',
};

export const vacanciesFilterData = {
  [vacanciesFilterKeys.groupId]: {
    key: vacanciesFilterKeys.groupId,
    initialValue: null,
  },
};
export const vacanciesFilterDataValues = Object.values(vacanciesFilterData);
